export enum UserFilterOption {
  Monthly100 = 'Desktop',
  Monthly50 = 'Mobile',
  NoSubscriptions = 'No Subscription',
  Trial = 'Trial',
  ActiveUsers = 'Active users',
  // EnabledUsers = "Enabled users",
  // ArchivedUsers = "Archived users",
}

export const defaultSubscriptionFilters = [
  UserFilterOption.Monthly50,
  UserFilterOption.Monthly100,
  UserFilterOption.NoSubscriptions,
  UserFilterOption.Trial,
].map((x) => {
  return {
    item: x,
    selected: false,
  };
});

export const defaultUserFilters = [
  UserFilterOption.ActiveUsers,
  // UserFilterOption.ArchivedUsers,
  // UserFilterOption.EnabledUsers,
].map((x) => {
  return {
    item: x,
    selected: false,
  };
});

export enum NoteStatusFilterOption {
  Uploaded = 'Uploaded',
  Processed = 'Processed',
  Draft = 'Draft',
  Finalized = 'Finalized',
  Search = 'Search',
}

export const defaultResultsFilters = [
  NoteStatusFilterOption.Uploaded,
  NoteStatusFilterOption.Processed,
  NoteStatusFilterOption.Draft,
  NoteStatusFilterOption.Finalized,
  NoteStatusFilterOption.Search,
].map((x) => {
  return {
    item: x,
    selected: false,
  };
});
